// Käyttöliittymän käännökset. Kaikki näkyvä copy avaimina, joista
// kieliversio valitaan LanguageContextin lang-arvon mukaan.

export const t = {
  nav: {
    work: { fi: "TYÖT", en: "WORK" },
    services: { fi: "PALVELUT", en: "SERVICES" },
    contact: { fi: "YHTEYS", en: "CONTACT" },
    home: { fi: "Hetki, etusivu", en: "Hetki, home" },
    homeFilm: { fi: "Hetki Film Company, etusivu", en: "Hetki Film Company, home" },
    open: { fi: "Avaa valikko", en: "Open menu" },
    close: { fi: "Sulje valikko", en: "Close menu" },
    main: { fi: "Päänavigaatio", en: "Main navigation" },
    language: { fi: "Kieli", en: "Language" },
  },

  home: {
    // Rivinvaihdot (\n) ovat kiinteät, jotta typewriter-teksti ei rivity
    // uudelleen kesken kirjoituksen. Accent alkaa aina omalta riviltään.
    // Kolme lausetta: vaikuttava visuaalinen viestintä, maailmasta parempi yksi
    // kuva kerrallaan, konkreettiset palvelut. Nimi jää logolle, eikä
    // kohderyhmiä luetella.
    statement: {
      fi: "Visuaalista viestintää,",
      en: "Visual communication",
    },
    statementAccent: {
      fi: "joka pysäyttää ja vaikuttaa.",
      en: "that stops and moves people.",
    },
    statement2: {
      fi: "Tehdään maailmasta parempi,",
      en: "Let's make the world better,",
    },
    statement2Accent: {
      fi: "yksi kuva kerrallaan.",
      en: "one frame at a time.",
    },
    statement3: {
      fi: "Kampanjat, brändifilmit,",
      en: "Campaigns, brand films,",
    },
    statement3Accent: {
      fi: "somesisällöt ja valokuvaus.",
      en: "social content and photography.",
    },
    // HETKI-osio: mitä Hetki tekee, kirjo ja tapa. Työt kertovat loput.
    missionBody: {
      fi: "Hetki tekee visuaalista viestintää ja markkinointia Helsingistä käsin. Mittakaava vaihtelee yhdestä valokuvasta koko kampanjaan.",
      en: "Hetki creates visual communication and marketing from Helsinki. The scale runs from a single photograph to an entire campaign.",
    },
    missionBody2: {
      fi: "Tapa tehdä valitaan sen mukaan, mitä viestin pitää saada aikaan. Työt kertovat loput.",
      en: "The approach follows what the message needs to achieve. The work says the rest.",
    },
    workTitle: { fi: "TYÖT", en: "WORK" },
    workBody: {
      fi: "Poimintoja viime vuosilta.",
      en: "Selected work from recent years.",
    },
    workCta: { fi: "Katso työt", en: "See our work" },
    servicesTitle: { fi: "PALVELUT", en: "SERVICES" },
    servicesBody: {
      fi: "Mitä teemme, lyhyesti.",
      en: "What we do, in brief.",
    },
    servicesCta: { fi: "Tutustu palveluihin", en: "Explore services" },
    momentumTitle: { fi: "MOMENTUM", en: "MOMENTUM" },
    momentumCta: { fi: "Lue lisää Momentumista", en: "Read more about Momentum" },
    contactHook: {
      fi: "Onko sinulla projekti mielessä?",
      en: "Got a project in mind?",
    },
    contactCta: { fi: "Ota yhteyttä", en: "Get in touch" },
    // Ruudunlukijan nimi hero-osiolle (showreel H-maskin läpi).
    heroLabel: { fi: "Hetken showreel", en: "Hetki showreel" },
  },

  gateway: {
    // Kaksi rinnakkaista nimilappua: logot kertovat nimet, kuvaus alan
    companyDesc: {
      fi: "Viestintä ja markkinointi",
      en: "Communications and marketing",
    },
    filmDesc: { fi: "Elokuvat ja sarjat", en: "Films and series" },
    // Puolikohtainen painike: kertoo mitä klikkaamalla löytyy
    companyEnter: { fi: "Katso työt", en: "See our work" },
    filmEnter: { fi: "Tutustu", en: "Explore" },
  },

  tyot: {
    prevVideo: { fi: "Edellinen video", en: "Previous video" },
    nextVideo: { fi: "Seuraava video", en: "Next video" },
    title: { fi: "TYÖT", en: "WORK" },
    intro: {
      fi: "Viime vuosien töitä kampanjoista tapahtumakuvaukseen. Jokaisen kohdalla kerromme, mitä teimme ja missä työ näkyi.",
      en: "Recent work, from campaigns to event photography. For each one: what we made and where it ran.",
    },
    productions: { fi: "ASIAKASTYÖT", en: "CLIENT WORK" },
    specClient: { fi: "Asiakas", en: "Client" },
    specYear: { fi: "Vuosi", en: "Year" },
    empty: { fi: "Töitä lisätään pian.", en: "More work coming soon." },
    // Sivun lopun CTA casejen jälkeen
    ctaTitle: { fi: "ONKO SINULLA PROJEKTI MIELESSÄ?", en: "GOT A PROJECT IN MIND?" },
    ctaBody: {
      fi: "Kerro lyhyesti, mitä tarvitset, niin ehdotamme tavan edetä.",
      en: "Tell us briefly what you need and we'll suggest a way forward.",
    },
    ctaLink: { fi: "Ota yhteyttä →", en: "Get in touch →" },
    ctaServices: { fi: "Katso palvelut →", en: "See our services →" },
    // Casevideon äänipainikkeen aria-label (Block.jsx)
    soundOn: { fi: "Kytke ääni päälle", en: "Turn sound on" },
    soundOff: { fi: "Mykistä ääni", en: "Mute" },
  },

  film: {
    title: { fi: "ELOKUVA", en: "FILM" },
    eyebrow: { fi: "Hetki Film Company", en: "Hetki Film Company" },
    intro1: {
      fi: "Hetki Film Company kehittää elokuvia, sarjoja ja dokumentteja yhteiskunnallisista aiheista kotimaiselle ja kansainväliselle yleisölle.",
      en: "Hetki Film Company develops films, series and documentaries on social themes, for audiences in Finland and abroad.",
    },
    intro2: {
      fi: "Useita hankkeita on käsikirjoitus- ja kehitysvaiheessa. Kerromme nimet ja tekijät, kun hankkeet etenevät.",
      en: "Several projects are in script and development. We will share titles and filmmakers as they move forward.",
    },
    ctaTitle: { fi: "YHTEISTYÖ", en: "COLLABORATION" },
    ctaBody: {
      fi: "Keskustelemme mielellämme ohjaajien, käsikirjoittajien, yhteistuottajien ja rahoittajien kanssa.",
      en: "We are glad to hear from directors, writers, co-producers and financiers.",
    },
    ctaLink: { fi: "Ota yhteyttä →", en: "Get in touch →" },
    // Kuvauskuvien alt-tekstit (Film.jsx)
    heroAlt: {
      fi: "Yökuvaus metsässä: puomittaja ja kuvaaja kasvillisuuden keskellä",
      en: "Night shoot in a forest: a boom operator and a camera operator among the plants",
    },
    photoAlt: {
      fi: "Yökuvaus rannalla: kuvausryhmä ja soutuvene",
      en: "Night shoot on the shore: the crew and a rowing boat",
    },
  },

  palvelut: {
    title: { fi: "PALVELUT", en: "SERVICES" },
    intro1: {
      fi: "Hetki suunnittelee ja toteuttaa visuaalista viestintää. Palvelut voi tilata erikseen tai yhtenä kokonaisuutena.",
      en: "Hetki plans and produces visual communication. Each service can be ordered on its own or as part of a whole.",
    },
    intro2: {
      fi: "Jos tarve on jokin muu, kerro siitä.",
      en: "If you need something else, tell us.",
    },
    whatWeDo: { fi: "MITÄ TEEMME", en: "WHAT WE DO" },
    ctaTitle: { fi: "ONKO SINULLA PROJEKTI MIELESSÄ?", en: "GOT A PROJECT IN MIND?" },
    ctaBody: {
      fi: "Kerro lyhyesti, mitä tarvitset. Palaamme asiaan saman päivän aikana.",
      en: "Tell us briefly what you need. We'll get back to you the same day.",
    },
    ctaLink: { fi: "Ota yhteyttä →", en: "Get in touch →" },
  },

  yhteys: {
    aria: { fi: "Otetaan yhteyttä", en: "Get in touch" },
    title: { fi: "Otetaan\nyhteyttä.", en: "Let's\nconnect." },
    titleSimple: { fi: "OTA YHTEYTTÄ", en: "GET IN TOUCH" },
    lead: {
      fi: "Kerro, mitä olet tekemässä. Voit myös jättää numerosi, niin soitamme. Vastaamme saman päivän aikana.",
      en: "Tell us what you're working on, or leave your number and we'll call. We reply the same day.",
    },
    visit: { fi: "Osoite", en: "Address" },
    write: { fi: "Sähköposti", en: "Email" },
    call: { fi: "Puhelin", en: "Phone" },
    social: { fi: "Some", en: "Social" },
    contactInfoLabel: { fi: "Yhteystiedot", en: "Contact" },
    formAria: { fi: "Yhteydenottolomake", en: "Contact form" },
    formNameLabel: { fi: "Nimi", en: "Name" },
    // Sähköposti ja puhelin ovat samassa ryhmässä: toinen riittää.
    formContactLegend: { fi: "Miten tavoitamme sinut?", en: "How can we reach you?" },
    formContactHint: {
      fi: "Sähköposti tai puhelin, toinen riittää.",
      en: "Email or phone, either is fine.",
    },
    formEmailLabel: { fi: "Sähköposti", en: "Email" },
    formPhoneLabel: { fi: "Puhelin", en: "Phone" },
    formMessageLabel: { fi: "Viesti", en: "Message" },
    formMessagePlaceholder: {
      fi: "Kerro lyhyesti asiasi tai pyydä, että soitamme.",
      en: "Tell us briefly what it's about, or ask us to call you.",
    },
    formSubmit: { fi: "Lähetä viesti", en: "Send message" },
    formSending: { fi: "Lähetetään…", en: "Sending…" },
    formSentTitle: { fi: "Kiitos yhteydenotosta.", en: "Thanks for getting in touch." },
    formSent: {
      fi: "Viesti tuli perille. Palaamme asiaan saman päivän aikana.",
      en: "Your message got through. We'll get back to you the same day.",
    },
    formSentCallback: {
      fi: "Pyyntö tuli perille. Soitamme sinulle saman päivän aikana.",
      en: "Your request got through. We'll call you the same day.",
    },
    formError: {
      fi: "Viesti ei lähtenyt. Kokeile uudelleen tai ota yhteyttä suoraan:",
      en: "Your message didn't go through. Please try again or contact us directly:",
    },
    formErrorKept: {
      fi: "Kirjoittamasi teksti on tallessa lomakkeessa.",
      en: "What you wrote is still in the form.",
    },
    // Validointivirheet näytetään kenttien vieressä vasta lähetysyrityksessä.
    formErrorName: { fi: "Kirjoita nimesi.", en: "Please add your name." },
    formErrorContact: {
      fi: "Jätä sähköposti tai puhelinnumero, niin tavoitamme sinut.",
      en: "Add an email or phone number so we can reach you.",
    },
    formErrorEmail: { fi: "Tarkista sähköpostiosoite.", en: "Please check the email address." },
    formErrorPhone: { fi: "Tarkista puhelinnumero.", en: "Please check the phone number." },
    formErrorSummary: { fi: "Tarkista merkityt kentät.", en: "Please check the highlighted fields." },
    formMailSubject: { fi: "Yhteydenottopyyntö", en: "Contact request" },
    // Tyhjä viestikenttä lähetetään tällä arvolla, jotta ilmoitus kertoo asian.
    formCallbackSubject: { fi: "Soittopyyntö", en: "Callback request" },
    formOrWhatsapp: { fi: "Tai lähetä viesti", en: "Or message us on" },
    formOrWhatsappBrand: { fi: "WhatsAppissa", en: "WhatsApp" },
    whatsapp: { fi: "WhatsApp", en: "WhatsApp" },
    whatsappGreeting: {
      fi: "Hei! Otan yhteyttä hetkicompany.com-sivun kautta.",
      en: "Hi! I'm reaching out via hetkicompany.com.",
    },
  },

  footer: {
    contact: { fi: "YHTEYSTIEDOT", en: "CONTACT DETAILS" },
    // Footerin sivulinkkien navigaation nimi ruudunlukijalle
    nav: { fi: "Sivut", en: "Pages" },
  },

  // Palvelut: nimi ja lyhyt kuvaus siitä, mitä teemme. Järjestys services.js:ssä.
  services: {
    kampanjat: {
      name: { fi: "Kampanjat ja mainokset", en: "Campaigns and commercials" },
      description: {
        fi: "Kampanjan idea ja mainokset jokaiseen kanavaan, jossa sen pitää näkyä.",
        en: "The campaign idea and the ads, for every channel it needs to reach.",
      },
    },
    brandifilmi: {
      name: { fi: "Brändifilmit", en: "Brand films" },
      description: {
        fi: "Filmi, joka kertoo, keitä olette ja mitä teette.",
        en: "A film that shows who you are and what you do.",
      },
    },
    somesisallot: {
      name: { fi: "Somesisällöt", en: "Social media content" },
      description: {
        fi: "Videot ja kuvat, jotka on tehty kanavaan, jossa ne nähdään.",
        en: "Video and photos made for the channel where they will be seen.",
      },
    },
    tapahtumat: {
      name: { fi: "Tapahtumat ja valokuvaus", en: "Events and photography" },
      description: {
        fi: "Tapahtumat videoina ja valokuvina viestintään ja somekanaviin.",
        en: "Your event on video and in photographs, for communications and social channels.",
      },
    },
    "yhteiskunnallinen-viestinta": {
      name: { fi: "Yhteiskunnallinen viestintä", en: "Social impact communication" },
      description: {
        fi: "Viestintää asioista, jotka koskevat meitä kaikkia.",
        en: "Communication on issues that concern all of us.",
      },
    },
  },

  projects: {
    "case-ala-anna-sen-kasvaa": {
      headline: { fi: ["ÄLÄ ANNA", "SEN KASVAA"], en: ["DON'T LET", "IT GROW"] },
      subheadline: {
        fi: "Aseman Lapset × Aivovammaliitto · 2025",
        en: "Aseman Lapset × Brain Injury Association of Finland · 2025",
      },
      body: {
        fi: "Aseman Lapset ry:n ja Aivovammaliiton kampanja nuorten katuväkivaltaa vastaan. Sen ydin on 60 sekunnin filmi väkivallasta ja aivovammoista, joita se aiheuttaa.",
        en: "A campaign by Aseman Lapset and the Brain Injury Association of Finland against youth street violence. At its core is a 60-second film about the violence and the brain injuries it causes.",
      },
      body2: {
        fi: "Käsikirjoitimme, ohjasimme ja tuotimme filmin. Kampanja näkyi ulkomainonnassa, elokuvateattereissa ja Ylen kanavilla. Katselukertoja kertyi yli 7 miljoonaa.",
        en: "We wrote, directed and produced the film. The campaign ran in outdoor advertising, in cinemas and on Yle's channels. It reached more than 7 million views.",
      },
    },
    "case-sun-effects": {
      mediaLabels: [
        { fi: "Slush 2025", en: "Slush 2025" },
        { fi: "Delta Life", en: "Delta Life" },
        { fi: "Flow Festival 2026", en: "Flow Festival 2026" },
      ],
      headline: { fi: ["SUN EFFECTS", "TOTEUTUKSET 2025–2026"], en: ["SUN EFFECTS", "PRODUCTIONS 2025–2026"] },
      subheadline: { fi: "Toteutusten dokumentointi · 2025–2026", en: "Documenting productions · 2025–2026" },
      body: {
        fi: "Sun Effects suunnittelee ja toteuttaa valo- ja tilaelämyksiä tapahtumiin. Vuosina 2025–2026 olemme kuvanneet studion toteutuksia lyhyiksi filmeiksi, muun muassa Slushissa, Flow Festivalilla ja Delta Lifessa.",
        en: "Sun Effects designs and builds light and spatial experiences for events. In 2025–2026 we have filmed the studio's productions as short films, at Slush, Flow Festival and Delta Life among others.",
      },
      body2: {
        fi: "Kuvasimme ja ohjasimme filmit ja teimme jälkituotannon Sun Effectsin somekanaviin ja referensseiksi. Kuvat ovat Slush 2025 -toteutuksesta.",
        en: "We shot, directed and finished the films for Sun Effects' social channels and as references. The photos are from the Slush 2025 production.",
      },
      galleryAlt: [
        { fi: "Valaistut verhot ja baaripöydät Slushin lounge-alueella", en: "Lit curtains and bar tables in the Slush lounge area" },
        { fi: "Slushin tapaamisalue ylhäältä kuvattuna", en: "Slush meeting area seen from above" },
        { fi: "Kaksi ihmistä keskustelee lavan edessä oranssissa valossa", en: "Two people talking in front of the stage in orange light" },
        { fi: "Vieras koskettaa sinistä valopaneelia", en: "A guest touching a blue light panel" },
        { fi: "Kulkijan siluetti sinisten valopaneelien edessä", en: "A silhouette walking past blue light panels" },
        { fi: "Punainen valopinta ruudukkona", en: "A red light surface in a grid pattern" },
        { fi: "Lavan valot ja valopallot trussissa", en: "Stage lights and light globes on the truss" },
      ],
    },
    "case-kuumaa-maasta-kuuhun": {
      headline: { fi: ["KUUMAA", "MAASTA KUUHUN"], en: ["KUUMAA", "FROM EARTH TO MOON"] },
      subheadline: { fi: "Kiertuemainos · 2024", en: "Tour campaign · 2024" },
      body: {
        fi: "Kampanjavideo Kuumaa-yhtyeen Maasta kuuhun -kiertueelle. Video yhdistää keikkojen energian ja kappaleen tunnelman, ja se on tehty someen.",
        en: "A campaign video for Kuumaa's Maasta kuuhun tour. It pairs the energy of the live shows with the mood of the song, and it's made for social.",
      },
      body2: {
        fi: "Ideoimme, kuvasimme ja leikkasimme videon kiertueen markkinointiin ja yhtyeen somekanaviin.",
        en: "We came up with the concept, shot it and cut it for the tour's marketing and the band's social channels.",
      },
    },
    "case-bastard-burgers-birthday": {
      mediaLabels: [
        { fi: "Bastard 3 vuotta", en: "Bastard 3 years" },
        { fi: "Rekrytointi Helsinki", en: "Recruitment Helsinki" },
      ],
      headline: { fi: ["BASTARD BURGERS", "SUOMI 2024–2026"], en: ["BASTARD BURGERS", "FINLAND 2024–2026"] },
      subheadline: { fi: "Videomarkkinointi · 2024–2026", en: "Video marketing · 2024–2026" },
      body: {
        fi: "Video Bastard Burgersin syntymäpäiväkampanjaan. Se puhuu brändin omalla äänellä ja on tehty someen, jossa ensimmäiset sekunnit ratkaisevat.",
        en: "A video for Bastard Burgers' birthday campaign. It speaks in the brand's own voice and is made for social, where the first seconds decide.",
      },
      body2: {
        fi: "Konsepti, kuvaus ja jälkituotanto ovat meidän käsialaamme. Video julkaistiin ketjun somekanavissa ja paikallismarkkinoinnissa kampanjan aikana.",
        en: "Concept, shoot and post-production are our work. The video ran on the chain's social channels and in local marketing during the campaign.",
      },
      galleryAlt: [
        { fi: "Bastard Burgersin julkisivu Kampissa kukkivien oksien takaa", en: "The Bastard Burgers storefront in Kamppi seen through blossoming branches" },
        { fi: "Käsi pitää burgeria spraymaalatun Bastard-seinän edessä", en: "A hand holding a burger in front of a spray-painted Bastard wall" },
        { fi: "Kokki paistaa pihvejä grillillä", en: "A cook grilling patties" },
        { fi: "Olutlasi hanan alla", en: "A beer glass under the tap" },
        { fi: "Kippis Helsinki Bryggerin oluilla ruokapöydän ääressä", en: "A toast with Helsinki Bryggeri beers over a table of food" },
        { fi: "Burgeri ja ranskalaiset laattapöydällä auringonvalossa", en: "A burger and fries on a tiled table in sunlight" },
        { fi: "Mozzarellatikut venyvät ystävien käsissä", en: "Mozzarella sticks stretched between friends' hands" },
        { fi: "Katujalkapalloa ravintolan edustalla", en: "Street football outside the restaurant" },
        { fi: "Esiintyjä mikrofonin kanssa avajaisissa", en: "A performer with a microphone at the opening" },
        { fi: "Laulaja ja DJ avajaislavalla", en: "A singer and DJ on the opening stage" },
        { fi: "Nuori syö ranskalaisia Bastard-kyltin alla", en: "A young guest eating fries under the Bastard sign" },
      ],
    },
    "case-oatly-kozeen": {
      headline: { fi: ["OATLY", "× KOZEEN"], en: ["OATLY", "× KOZEEN"] },
      subheadline: {
        fi: "Brändiyhteistyö · highlight reel · 2025",
        en: "Brand collaboration · highlight reel · 2025",
      },
      body: {
        fi: "Highlight reel Oatlyn ja Kozeenin brändiyhteistyöstä. Kahden brändin yhteinen sävy yhdessä koosteessa.",
        en: "A highlight reel from Oatly and Kozeen's brand collaboration. Two brands and one shared tone in a single cut.",
      },
      body2: {
        fi: "Teimme konseptin, kuvauksen ja jälkituotannon. Video julkaistiin molempien brändien somekanavissa.",
        en: "We did the concept, filming and post-production. The video was released on both brands' social channels.",
      },
    },
    "case-lapinlahden-lahde-vuokralaisvideo": {
      headline: { fi: ["LAPINLAHDEN", "LÄHDE"], en: ["LAPINLAHDEN", "LÄHDE"] },
      subheadline: {
        fi: "Vuokralaisvideo · 2025",
        en: "Tenant recruitment video · 2025",
      },
      body: {
        fi: "Lapinlahden Lähteellä kohtaavat kulttuuri, mielen hyvinvointi ja yrittäjyys. Vuokralaisvideo esittelee paikan yhteisön ja tilat.",
        en: "Lapinlahden Lähde is where culture, mental wellbeing and entrepreneurship meet. The tenant video introduces its community and spaces.",
      },
      body2: {
        fi: "Käsikirjoitimme ja kuvasimme videon ja teimme jälkituotannon. Se auttaa löytämään uusia vuokralaisia ja tukee paikan brändityötä.",
        en: "We wrote and filmed the video and did the post-production. It helps find new tenants and supports the venue's brand.",
      },
    },
    "case-llff-2026-traileri": {
      headline: { fi: ["LAPINLAHDEN", "ELOKUVAJUHLAT"], en: ["LAPINLAHTI", "FILM FESTIVAL"] },
      subheadline: { fi: "Festivaalitraileri · 2026", en: "Festival trailer · 2026" },
      body: {
        fi: "Traileri Lapinlahden elokuvajuhlien vuoden 2026 festivaalille. Se kutsuu yleisön Lapinlahden Lähteelle ja näyttää, miltä festivaali tuntuu.",
        en: "The trailer for the 2026 Lapinlahti Film Festival. It invites audiences to Lapinlahden Lähde and shows what the festival feels like.",
      },
      body2: {
        fi: "Osuutemme oli suunnittelu, tuotanto ja jälkituotanto. Traileri julkaistiin festivaalin somekanavissa ja verkkosivuilla.",
        en: "Our part was design, production and post-production. The trailer was released on the festival's social channels and website.",
      },
    },
    "case-jonsbok-suurlahetysto": {
      headline: { fi: ["JÓNSBÓK", "ISLANNIN SUURLÄHETYSTÖ"], en: ["JÓNSBÓK", "EMBASSY OF ICELAND"] },
      subheadline: { fi: "Tapahtumakuvaus · 2026", en: "Event photography · 2026" },
      body: {
        fi: "Jónsbók on vuonna 2024 Reykjavíkissa perustettu legal tech -yhtiö. Sen tekoälyalusta auttaa juristeja tiedonhaussa, analyysissa ja asiakirjojen laatimisessa.",
        en: "Jónsbók is a legal tech company founded in Reykjavík in 2024. Its AI platform helps lawyers with legal research, analysis and drafting.",
      },
      body2: {
        fi: "Kuvasimme Jónsbókin tilaisuuden Islannin suurlähetystössä Helsingissä vuonna 2026. Kuvat on tehty Jónsbókin viestintään ja somekanaviin.",
        en: "We photographed Jónsbók's event at the Embassy of Iceland in Helsinki in 2026. The photos were made for Jónsbók's communications and social channels.",
      },
      mediaAlt: {
        fi: "Jónsbókin tilaisuus Islannin suurlähetystön salissa Helsingissä",
        en: "Jónsbók's event in the hall of the Embassy of Iceland in Helsinki",
      },
    },
  },

  site: {
    momentumDescription: {
      fi: "Momentum on Hetken kehittämä työkalu tiimeille, joilla on monta lankaa käsissä.",
      en: "Momentum is a tool built by Hetki for teams juggling many threads.",
    },
  },

  // Sivukohtaiset hakukone- ja jakotekstit, avain = reitti (src/data/seo.js).
  // PageMeta asettaa ne selaimessa kielen mukaan, ja build-vaiheen
  // scripts/write-route-meta.mjs kirjoittaa fi-versiot build/<reitti>/index.html-
  // kopioihin (title, description, og- ja twitter-tagit), jotta WhatsApp,
  // LinkedIn ja hakukoneet näkevät ne ilman JavaScriptiä.
  // Title alle 60 merkkiä, description noin 120-155 merkkiä. Hetki-puolella
  // nimi on "Hetki", Film-puolella "Hetki Film Company"; vain portti mainitsee molemmat.
  meta: {
    portti: {
      title: {
        fi: "Hetki Company · Viestintä, markkinointi ja elokuva",
        en: "Hetki Company · Communications, marketing and film",
      },
      description: {
        fi: "Hetki Company, Helsinki. Hetki tekee viestintää, markkinointia ja sisältöjä. Hetki Film Company tuottaa elokuvia, sarjoja ja dokumentteja.",
        en: "Hetki Company, Helsinki. Hetki creates communications, marketing and content. Hetki Film Company produces films, series and documentaries.",
      },
    },
    hetki: {
      title: {
        fi: "Hetki · Visuaalinen viestintä ja markkinointi",
        en: "Hetki · Visual communications and marketing",
      },
      description: {
        fi: "Hetki on helsinkiläinen tuotantoyhtiö, joka tekee visuaalista viestintää ja markkinointia: brändifilmejä, mainoksia, kampanjoita ja somesisältöjä.",
        en: "Hetki is a Helsinki production company creating visual communications and marketing: brand films, commercials, campaigns and social content.",
      },
    },
    tyot: {
      title: { fi: "Työt · Hetki", en: "Work · Hetki" },
      description: {
        fi: "Valikoima Hetken töitä: brändifilmejä, mainoksia, kampanjoita, tapahtumasisältöjä ja valokuvausta kotimaisille ja kansainvälisille asiakkaille.",
        en: "Selected work by Hetki: brand films, commercials, campaigns, event content and photography for Finnish and international clients.",
      },
    },
    palvelut: {
      title: { fi: "Palvelut · Hetki", en: "Services · Hetki" },
      description: {
        fi: "Hetken palvelut ideasta valmiiseen sisältöön: konsepti ja käsikirjoitus, tuotanto ja kuvaus, jälkituotanto sekä brändifilmit ja mainokset.",
        en: "Hetki's services from idea to finished content: concept and script, production and filming, post-production, brand films and commercials.",
      },
    },
    yhteys: {
      title: { fi: "Yhteys · Hetki", en: "Contact · Hetki" },
      description: {
        fi: "Kerro Hetkelle projektistasi lomakkeella, sähköpostilla, puhelimitse tai WhatsAppissa. Toimimme Helsingissä ja vastaamme nopeasti.",
        en: "Tell Hetki about your project using the form, by email, by phone or on WhatsApp. We are based in Helsinki and reply quickly.",
      },
    },
    film: {
      title: {
        fi: "Hetki Film Company · Elokuvat, sarjat ja dokumentit",
        en: "Hetki Film Company · Films, series and documentaries",
      },
      description: {
        fi: "Hetki Film Company kehittää ja tuottaa pitkiä elokuvia, dokumentteja ja tv-sarjoja Suomeen ja kansainvälisesti. Useita tuotantoja on kehitteillä.",
        en: "Hetki Film Company develops and produces feature films, documentaries and TV series in Finland and internationally. Several projects are in development.",
      },
    },
  },
};
